export default function getNavigationInitialState() {
    return {
        limit: 0,
        pages: 0,
        count: 0,
    };
}